import { v4 as uuidV4 } from 'uuid';
import axios from 'axios';
import { useEnv } from '@/utils/env';
import { get } from '@vueuse/core';
import { cgiModeMap } from '@/service/const';
import { isFromActiveCache } from '@/utils/common';

let LogCache: any[] = [];

function getReportUrl() {
  const { env } = useEnv();
  const host: Record<string, string> = {
    production: cgiModeMap.production,
    prerelease: cgiModeMap.prerelease,
    default: location.origin,
  };
  return `//${host[get(env)] || host.default}/api/report`;
}

function getReportLogs() {
  const reportSearchParams = new URLSearchParams();
  // clone 一份等塞完之后，把cache给删掉
  const reportLogs = [...LogCache];
  LogCache = [];
  reportSearchParams.set(
    'logs',
    JSON.stringify(
      reportLogs.map((i) => ({
        ...i,
        requestid: uuidV4(),
        build_id: window.VITE_MI_BUILD_ID,
      })),
    ),
  );
  return reportLogs.length > 0 ? reportSearchParams : false;
}

/**
 * 将上报和其他请求逻辑要做分离
 */
export function reportRequest() {
  if (isFromActiveCache()) return; // 来自主动缓存不上报（页面url携带&from_active_cache=1参数情况）
  // 调用aixos 请求后台
  const logs = getReportLogs();
  if (logs) {
    axios.post(getReportUrl(), logs).then(() => {});
  }
}

export function reportLogByBeacon() {
  const logs = getReportLogs();
  if (logs) {
    navigator.sendBeacon(getReportUrl(), logs);
  }
}

/**
 * 将上报按照分钟为粒度进行聚合
 */
export function reportPool(log: any) {
  console.info('report', log);
  LogCache.push(log);
}

/**
 * 提供一个方法来延迟上报
 */
export function addReportWindowCloseEvent() {
  // 提供一个定时器，进行上报聚合
  let timer: any = null;
  const reportTimerFunc = () => {
    timer && clearTimeout(timer);
    timer = setTimeout(() => {
      reportRequest();
      reportTimerFunc();
    }, 60000);
  };
  reportTimerFunc();
  // 页面切换到不可见的状态
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') {
      clearTimeout(timer);
      reportLogByBeacon();
    }
  });
  // 页面关闭
  document.addEventListener('onbeforeunload', () => {
    reportLogByBeacon();
  });
}
